import React from "react";
import PropTypes from "prop-types";
import Badge from "../Badge/BadgeFolded";

const CardDocument = (props) => {
    const filigramClass = props.showFiligram ? "filigram" : "";
    const visibleClass = props.showContent ? "visible " : "invisible ";

    return (
        <div id="cardDocument" className={"card " + visibleClass + filigramClass} >
            {props.showBadge &&
                <Badge id="cardBadge" label={props.badgeLabel} className="bg-pink" />
            }
            <div className="card-body">
                <div className="card-text">
                    {props.children}
                </div>
            </div>
        </div>
    )
}

CardDocument.defaultProps = {
    showFiligram: false,
    showBadge: false,
    badgeLabel: "BETA",
    showContent: true
}

CardDocument.propTypes = {
    showFiligram: PropTypes.bool,
    showBadge: PropTypes.bool,
    badgeLabel: PropTypes.string,
    showContent: PropTypes.bool
}

export default (CardDocument);